/* Lumen theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var theme = window.theme || {};

  /* ---------------------------------------------------------------
     Drawers & overlay
  --------------------------------------------------------------- */
  var overlay = null;
  var lastFocus = null;

  function openDrawer(drawer) {
    if (!drawer) return;
    overlay = overlay || $('[data-overlay]');
    closeAll(true);
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    document.body.classList.add('is-locked');
    var focusable = drawer.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }

  function closeAll(silent) {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    var modal = $('#SearchModal');
    if (modal) modal.hidden = true;
    overlay = overlay || $('[data-overlay]');
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('is-locked');
    $$('[aria-expanded="true"][data-drawer-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-drawer-toggle]');
    if (toggle) {
      var target = document.getElementById(toggle.getAttribute('data-drawer-toggle'));
      if (target) {
        e.preventDefault();
        toggle.setAttribute('aria-expanded', 'true');
        openDrawer(target);
      }
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-overlay]')) {
      e.preventDefault();
      closeAll();
      return;
    }
    var searchToggle = e.target.closest('[data-open-search]');
    if (searchToggle) {
      e.preventDefault();
      var modal = $('#SearchModal');
      if (!modal) return;
      closeAll(true);
      lastFocus = searchToggle;
      modal.hidden = false;
      overlay = overlay || $('[data-overlay]');
      if (overlay) overlay.hidden = false;
      setTimeout(function () { var i = $('#SearchModalInput'); if (i) i.focus(); }, 50);
      return;
    }
    if (e.target.closest('[data-close-search]')) { closeAll(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ---------------------------------------------------------------
     Header: sticky state
  --------------------------------------------------------------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var root = document.documentElement;
    var setHeight = function () { root.style.setProperty('--header-height', header.offsetHeight + 'px'); };
    setHeight();
    window.addEventListener('resize', setHeight);
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------------------------------------------------------
     Announcement bar rotation
  --------------------------------------------------------------- */
  function initAnnouncements() {
    $$('[data-announcement]').forEach(function (bar) {
      var slides = $$('.announcement__slide', bar);
      if (slides.length < 2) return;
      var i = 0;
      var speed = parseInt(bar.getAttribute('data-speed') || '5', 10) * 1000;
      setInterval(function () {
        if (window.matchMedia('(min-width: 990px)').matches && bar.classList.contains('announcement--split')) return;
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------------------------------------------------------------
     Cart (AJAX + drawer)
  --------------------------------------------------------------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  function renderCartSections(sections) {
    if (!sections) return;
    var html = sections['cart-drawer'];
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-inner]');
    var current = $('[data-cart-drawer-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var countEl = doc.querySelector('[data-cart-drawer-count]');
    if (countEl) updateCartCount(parseInt(countEl.getAttribute('data-cart-drawer-count'), 10) || 0);
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw data;
        return data;
      });
    });
  }

  function showFormError(form, msg) {
    var box = form.querySelector('[data-form-error]');
    if (!box) return;
    box.textContent = msg || theme.strings.error;
    box.hidden = false;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || theme.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    if (button) button.classList.add('is-loading');
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { showFormError(form, data.description || data.message); return; }
        renderCartSections(data.sections);
        openDrawer($('[data-cart-drawer]'));
      })
      .catch(function () { showFormError(form); })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  });

  function changeLine(key, quantity, container) {
    if (container) container.style.opacity = '.5';
    cartRequest(theme.routes.cartChange + '.js', { id: key, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      .then(function (data) { renderCartSections(data.sections); })
      .catch(function (e) { alertCartError(e); if (container) container.style.opacity = ''; });
  }

  function alertCartError(e) {
    var box = $('[data-cart-error]');
    if (box) { box.textContent = (e && (e.description || e.message)) || theme.strings.error; box.hidden = false; }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-qty]');
    if (btn && btn.closest('[data-cart-drawer]')) {
      e.preventDefault();
      var line = btn.closest('[data-line-key]');
      var input = line.querySelector('input');
      var q = parseInt(input.value, 10) || 0;
      q = btn.getAttribute('data-line-qty') === 'plus' ? q + 1 : Math.max(0, q - 1);
      changeLine(line.getAttribute('data-line-key'), q, line);
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm && rm.closest('[data-cart-drawer]')) {
      e.preventDefault();
      var l = rm.closest('[data-line-key]');
      changeLine(l.getAttribute('data-line-key'), 0, l);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-drawer] [data-line-key] input[type="number"]');
    if (input) {
      var line = input.closest('[data-line-key]');
      changeLine(line.getAttribute('data-line-key'), parseInt(input.value, 10) || 0, line);
    }
    var note = e.target.closest('[data-cart-note]');
    if (note) {
      cartRequest(theme.routes.cartUpdate + '.js', { note: note.value }).catch(function () {});
    }
  });

  /* ---------------------------------------------------------------
     Quantity steppers (product + cart page)
  --------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var wrap = b.closest('.quantity');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    e.preventDefault();
    var min = parseInt(input.min || '0', 10);
    var v = parseInt(input.value, 10) || 0;
    v = b.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------
     Product: variants, gallery, delivery estimate, sticky ATC
  --------------------------------------------------------------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var form = root.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var groups = $$('[data-option-group]', root);

    function selectedOptions() {
      return groups.map(function (g) {
        var checked = g.querySelector('input:checked');
        var select = g.querySelector('select');
        return checked ? checked.value : (select ? select.value : null);
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { match = false; break; } }
        if (match) return v;
      }
      return null;
    }

    function markAvailability(opts) {
      groups.forEach(function (g, gi) {
        $$('input[type="radio"]', g).forEach(function (input) {
          var test = opts.slice();
          test[gi] = input.value;
          var v = findVariant(test);
          input.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      groups.forEach(function (g, gi) {
        var out = g.querySelector('[data-selected-value]');
        if (out) out.textContent = opts[gi] || '';
      });
      markAvailability(opts);
      var btns = $$('[data-add-button]', root.ownerDocument);
      if (!v) {
        btns.forEach(function (b) { b.disabled = true; b.querySelector('[data-add-label]').textContent = theme.strings.unavailable; });
        return;
      }
      if (idInput) idInput.value = v.id;
      $$('[data-price]', root).forEach(function (el) { el.innerHTML = v.price; });
      $$('[data-compare-price]', root).forEach(function (el) {
        if (v.compare) { el.innerHTML = v.compare; el.hidden = false; } else { el.hidden = true; }
      });
      $$('[data-price-wrapper]', root).forEach(function (el) { el.classList.toggle('price--sale', !!v.compare); });
      var save = root.querySelector('[data-save]');
      if (save) { if (v.save) { save.textContent = v.save; save.hidden = false; } else save.hidden = true; }
      var sku = root.querySelector('[data-sku]');
      if (sku) { sku.textContent = v.sku || ''; sku.parentElement.hidden = !v.sku; }
      var stock = root.querySelector('[data-stock]');
      if (stock) {
        stock.classList.toggle('stock--out', !v.available);
        var t = stock.querySelector('[data-stock-text]');
        if (t) t.textContent = v.available ? stock.getAttribute('data-in') : stock.getAttribute('data-out');
      }
      btns.forEach(function (b) {
        b.disabled = !v.available;
        var label = b.querySelector('[data-add-label]');
        if (label) label.textContent = v.available ? theme.strings.addToCart : theme.strings.soldOut;
      });
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.innerHTML = v.price;
      if (v.media_id) goToMedia(v.media_id);
      if (data.updateUrl && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('variant:change', { detail: v, bubbles: true }));
    }

    groups.forEach(function (g) { g.addEventListener('change', update); });

    /* gallery */
    var viewport = root.querySelector('[data-gallery-viewport]');
    var thumbs = $$('[data-thumb]', root);
    var counter = root.querySelector('[data-gallery-counter]');
    function slides() { return viewport ? $$('[data-media-id]', viewport) : []; }
    function goToIndex(i, smooth) {
      if (!viewport) return;
      var s = slides();
      if (!s[i]) return;
      viewport.scrollTo({ left: s[i].offsetLeft - viewport.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function goToMedia(id) {
      var s = slides();
      for (var i = 0; i < s.length; i++) { if (s[i].getAttribute('data-media-id') === String(id)) { goToIndex(i); return; } }
    }
    function currentIndex() {
      if (!viewport || !viewport.clientWidth) return 0;
      return Math.round(viewport.scrollLeft / viewport.clientWidth);
    }
    if (viewport) {
      var t;
      viewport.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = currentIndex();
          thumbs.forEach(function (th, ti) { th.classList.toggle('is-active', ti === i); });
          if (counter) counter.textContent = (i + 1) + ' / ' + slides().length;
        }, 60);
      }, { passive: true });
      thumbs.forEach(function (th, ti) { th.addEventListener('click', function () { goToIndex(ti); }); });
      $$('[data-gallery-prev]', root).forEach(function (b) { b.addEventListener('click', function () { var i = currentIndex(); goToIndex(i > 0 ? i - 1 : slides().length - 1); }); });
      $$('[data-gallery-next]', root).forEach(function (b) { b.addEventListener('click', function () { var i = currentIndex(); goToIndex(i < slides().length - 1 ? i + 1 : 0); }); });
    }

    /* initial state */
    if (groups.length) markAvailability(selectedOptions());
    if (data.initialMedia) setTimeout(function () {
      var s = slides();
      for (var i = 0; i < s.length; i++) { if (s[i].getAttribute('data-media-id') === String(data.initialMedia)) { goToIndex(i, false); break; } }
    }, 0);

    /* sticky add to cart */
    var sticky = document.querySelector('[data-sticky-atc]');
    var mainBtn = form && form.querySelector('[data-add-button]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var past = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
        });
      }).observe(mainBtn);
      var sb = sticky.querySelector('button');
      if (sb) sb.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
      });
    }
  }

  /* Delivery estimate: adds business days, skipping weekends */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  function initDeliveryEstimates() {
    $$('[data-delivery-estimate]').forEach(function (el) {
      var s = theme.shipping || {};
      var now = new Date();
      var from = addBusinessDays(now, (s.processingMin || 1) + (s.transitMin || 3));
      var to = addBusinessDays(now, (s.processingMax || 2) + (s.transitMax || 5));
      var fmt = { weekday: 'short', month: 'short', day: 'numeric' };
      try {
        el.textContent = from.toLocaleDateString('en-US', fmt) + ' – ' + to.toLocaleDateString('en-US', fmt);
      } catch (err) { /* keep fallback text */ }
    });
  }

  /* ---------------------------------------------------------------
     Hero slideshow
  --------------------------------------------------------------- */
  function initHero(root) {
    var slides = $$('.hero__slide', root);
    var dots = $$('.hero__dot', root);
    if (slides.length < 2) return;
    var i = 0;
    var timer;
    function go(n) {
      slides[i].classList.remove('is-active'); if (dots[i]) { dots[i].classList.remove('is-active'); dots[i].setAttribute('aria-current', 'false'); }
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (dots[i]) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
    }
    dots.forEach(function (d, di) { d.addEventListener('click', function () { go(di); restart(); }); });
    var speed = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    function restart() { clearInterval(timer); if (speed > 0) timer = setInterval(function () { go(i + 1); }, speed * 1000); }
    restart();
  }

  /* ---------------------------------------------------------------
     Horizontal sliders
  --------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-slider-prev], [data-slider-next]');
    if (!b) return;
    var track = document.getElementById(b.getAttribute('aria-controls'));
    if (!track) return;
    var dir = b.hasAttribute('data-slider-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------------------------------------------------------------
     Collection filters: auto-submit
  --------------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var f = e.target.closest('[data-filter-form]');
    if (!f) return;
    if (e.target.matches('input[type="number"]')) return;
    submitFilters(f);
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-filter-form]');
    if (!f) return;
    e.preventDefault();
    submitFilters(f);
  });
  function submitFilters(f) {
    var params = new URLSearchParams();
    new FormData(f).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var sort = document.querySelector('[data-sort-select]');
    if (sort && !params.has('sort_by')) params.set('sort_by', sort.value);
    window.location.search = params.toString();
  }
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-sort-select]');
    if (!s) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------------------------------------------------------------
     Track by tracking number (opens universal carrier tracker)
  --------------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-tracking-form]');
    if (!f) return;
    e.preventDefault();
    var input = f.querySelector('input[name="tracking_number"]');
    var num = (input && input.value || '').replace(/\s+/g, '').trim();
    if (!num) { if (input) input.focus(); return; }
    var base = f.getAttribute('data-tracker') || 'https://t.17track.net/en#nums=';
    window.open(base + encodeURIComponent(num), '_blank', 'noopener');
  });

  /* ---------------------------------------------------------------
     Product recommendations
  --------------------------------------------------------------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          initReveal(el);
        } else {
          var section = el.closest('.shopify-section');
          if (section) section.hidden = true;
        }
      }).catch(function () {});
    });
  }

  /* ---------------------------------------------------------------
     Policy table of contents highlight
  --------------------------------------------------------------- */
  function initToc() {
    var links = $$('[data-toc] a');
    if (!links.length || !('IntersectionObserver' in window)) return;
    var map = {};
    links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          links.forEach(function (a) { a.classList.remove('is-active'); });
          var a = map[en.target.id];
          if (a) a.classList.add('is-active');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    Object.keys(map).forEach(function (id) { var s = document.getElementById(id); if (s) io.observe(s); });
  }

  /* ---------------------------------------------------------------
     Reveal on scroll
  --------------------------------------------------------------- */
  function initReveal(ctx) {
    var els = $$('.reveal:not(.is-visible)', ctx);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------
     Boot
  --------------------------------------------------------------- */
  function boot(ctx) {
    $$('[data-product-root]', ctx).forEach(initProduct);
    $$('[data-hero]', ctx).forEach(initHero);
    initDeliveryEstimates();
    initReveal(ctx);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initAnnouncements();
    initRecommendations();
    initToc();
    boot(document);
  });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); initHeader(); initAnnouncements(); initRecommendations(); });
  document.addEventListener('shopify:section:select', function (e) {
    var d = e.target.querySelector('[data-cart-drawer]');
    if (d) openDrawer(d);
  });
})();
